import styled, {keyframes} from 'styled-components';
import {basicColor} from '../../../../../styles/template';


const DashAnimation =  keyframes`
    to {
      stroke-dashoffset: 0;
    }
`

export const WrongSVGWrap = styled.svg`
    position: absolute;
    width: 4rem;
    height: 4rem;
    top: -5px;
    left: -4px;
    pointer-events: none;

  & path {
        stroke-dasharray: 200;
        stroke-dashoffset: 200;
        stroke: ${basicColor.red};
        stroke-width: 10px;
        stroke-linecap: round;
        stroke-linejoin: round;
        fill: none;
        animation: ${DashAnimation} 0.2s linear forwards;
    }
`

